var map = {
	"./air_icon": "./app/assets/images/air_icon.png",
	"./air_icon.png": "./app/assets/images/air_icon.png",
	"./alpha": "./app/assets/images/alpha.png",
	"./alpha.png": "./app/assets/images/alpha.png",
	"./back-red": "./app/assets/images/back-red.svg",
	"./back-red.svg": "./app/assets/images/back-red.svg",
	"./hue": "./app/assets/images/hue.png",
	"./hue.png": "./app/assets/images/hue.png",
	"./logo": "./app/assets/images/logo.png",
	"./logo-admin": "./app/assets/images/logo-admin.svg",
	"./logo-admin.svg": "./app/assets/images/logo-admin.svg",
	"./logo.png": "./app/assets/images/logo.png",
	"./logo.svg": "./app/assets/images/logo.svg",
	"./menu-white-arrow": "./app/assets/images/menu-white-arrow.png",
	"./menu-white-arrow.png": "./app/assets/images/menu-white-arrow.png",
	"./navimind-editor": "./app/assets/images/navimind-editor.png",
	"./navimind-editor.png": "./app/assets/images/navimind-editor.png",
	"./naviplan": "./app/assets/images/naviplan.svg",
	"./naviplan.svg": "./app/assets/images/naviplan.svg",
	"./packager": "./app/assets/images/packager.svg",
	"./packager.svg": "./app/assets/images/packager.svg",
	"./robot": "./app/assets/images/robot.svg",
	"./robot.svg": "./app/assets/images/robot.svg",
	"./robot_alert": "./app/assets/images/robot_alert.svg",
	"./robot_alert.svg": "./app/assets/images/robot_alert.svg",
	"./robots": "./app/assets/images/robots.svg",
	"./robots.svg": "./app/assets/images/robots.svg",
	"./saturation": "./app/assets/images/saturation.png",
	"./saturation.png": "./app/assets/images/saturation.png",
	"./schema": "./app/assets/images/schema.svg",
	"./schema.svg": "./app/assets/images/schema.svg",
	"./terminal": "./app/assets/images/terminal.png",
	"./terminal.png": "./app/assets/images/terminal.png",
	"./timer-piece": "./app/assets/images/timer-piece.png",
	"./timer-piece.png": "./app/assets/images/timer-piece.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/assets/images sync recursive ^\\.\\/.*$";